var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgErrorIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 30.5,
    fill: "#0049FF",
    fillOpacity: 0.86
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#0049FF",
    fillOpacity: 0.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1689 25.8H40.8649L39.7489 42.252H35.2849L34.1689 25.8ZM37.5169 51.288C36.5329 51.288 35.7049 50.976 35.0329 50.352C34.3849 49.704 34.0609 48.924 34.0609 48.012C34.0609 47.1 34.3849 46.344 35.0329 45.744C35.6809 45.12 36.5089 44.808 37.5169 44.808C38.5249 44.808 39.3529 45.12 40.0009 45.744C40.6489 46.344 40.9729 47.1 40.9729 48.012C40.9729 48.924 40.6369 49.704 39.9649 50.352C39.3169 50.976 38.5009 51.288 37.5169 51.288Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error-icon.6450026d.svg";
export { ForwardRef as ReactComponent };